import React, { useRef, useEffect, useState } from "react";
import villaImg from "../../../assets-user/villa.png";
import apartmentImg from "../../../assets-user/Apartments.png";
import landImg from "../../../assets-user/Land.png";
import { useNavigate } from "react-router-dom";

const PropertyCategories = () => {
  const navigate = useNavigate();
  const scrollContainerRef = useRef(null);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const categories = [
    {
      title: "Independent House/ Villa",
      properties: "2000+ Properties",
      image: villaImg,
      alt: "Independent House and Villa",
      route: "/properties",
    },
    {
      title: "Residential Apartments",
      properties: "2000+ Properties",
      image: apartmentImg,
      alt: "Residential Apartments",
      route: "/properties",
    },
    {
      title: "Commercial/ Land",
      properties: "2000+ Properties",
      image: landImg,
      alt: "Commercial Property and Land",
      route: "/properties/land",
    },
  ];

  // Only 2 copies needed for smooth infinite scroll
  const loopCategories = [...categories, ...categories];

  // Screen size listener
  useEffect(() => {
    const checkScreen = () => setIsSmallScreen(window.innerWidth < 1024);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // Auto scroll only on mobile/tablet
  useEffect(() => {
    if (!isSmallScreen) return;

    const container = scrollContainerRef.current;
    if (!container) return;

    let animationFrame;
    const step = 1;
    const resetPoint = container.scrollWidth / 2;

    const scroll = () => {
      if (container.scrollLeft >= resetPoint) {
        container.scrollLeft = 0;
      }
      container.scrollLeft += step;
      animationFrame = requestAnimationFrame(scroll);
    };

    animationFrame = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationFrame);
  }, [isSmallScreen]);

  const handleCardClick = (route) => {
    window.scrollTo(0, 0);
    navigate(route);
  };

  return (
    <div className="w-full bg-white px-4 sm:px-6 lg:px-10">
      <div className="mx-auto">
        {isSmallScreen ? (
          /* -------- MOBILE SCROLLING LIST -------- */
          <div
            ref={scrollContainerRef}
            className="flex gap-4 md:gap-6 overflow-x-auto whitespace-nowrap no-scrollbar"
          >
            {loopCategories.map((category, index) => (
              <div
                key={index}
                className="relative rounded-xl overflow-hidden shadow-lg h-56 sm:h-64 md:h-72 flex-shrink-0 w-[78%] sm:w-[65%] cursor-pointer"
                onClick={() => handleCardClick(category.route)}
              >
                {/* Background Image */}
                <img
                  src={category.image}
                  alt={category.alt}
                  className="absolute inset-0 w-full h-full object-cover"
                />

                {/* TOP TEXT SECTION (Your Original Layout) */}
                <div className="relative p-4 md:p-6 h-full flex flex-col justify-start bg-gradient-to-b from-black/50 via-black/10 to-transparent">
                  <h3 className="font-[Poppins] font-semibold text-white text-base sm:text-lg md:text-xl w-2/3 leading-snug mb-2">
                    {category.title}
                  </h3>
                  <p className="text-gray-300 text-xs sm:text-sm md:text-base">
                    {category.properties}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-3 gap-6">
            {categories.map((category, index) => (
              <div
                key={index}
                className="relative rounded-xl overflow-hidden shadow-lg h-64 cursor-pointer"
                onClick={() => handleCardClick(category.route)}
              >
                <img
                  src={category.image}
                  alt={category.alt}
                  className="absolute inset-0 w-full h-full object-cover"
                />

                {/* TOP TEXT — SAME AS ORIGINAL */}
                <div className="relative p-6 h-full flex flex-col justify-start bg-gradient-to-b from-black/50 via-black/10 to-transparent">
                  <h3 className="font-[Poppins] font-semibold text-white text-xl lg:text-2xl w-1/2 leading-snug mb-2">
                    {category.title}
                  </h3>
                  <p className="text-gray-300 text-base">
                    {category.properties}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyCategories;

// import React, { useRef, useEffect, useState } from "react";
// import villaImg from "../../../assets-user/villa.png";
// import apartmentImg from "../../../assets-user/Apartments.png";
// import landImg from "../../../assets-user/Land.png";
// import { useNavigate } from "react-router-dom";

// const PropertyCategories = () => {
//   const navigate = useNavigate();
//   const scrollContainerRef = useRef(null);
//   const [isHovered, setIsHovered] = useState(false);
//   const [isSmallOrMedium, setIsSmallOrMedium] = useState(false);

//   const categories = [
//     {
//       title: "Independent House/ Villa",
//       properties: "2000+ Properties",
//       image: villaImg,
//       alt: "Independent House and Villa",
//       route: "/properties",
//     },
//     {
//       title: "Residential Apartments",
//       properties: "2000+ Properties",
//       image: apartmentImg,
//       alt: "Residential Apartments",
//       route: "/properties",
//     },
//     {
//       title: "Commercial/ Land",
//       properties: "2000+ Properties",
//       image: landImg,
//       alt: "Commercial Property and Land",
//       route: "/properties/land",
//     },
//   ];

//   // Duplicate categories for seamless scroll
//   const doubledCategories = [...categories, ...categories, ...categories];

//   const handleCardClick = (route) => {
//     window.scrollTo(0, 0);
//     navigate(route);
//   };

//   // Check screen size for enabling scroll
//   useEffect(() => {
//     const checkScreenSize = () => {
//       // Tailwind's lg breakpoint is 1024px. Scroll only on < 1024px
//       setIsSmallOrMedium(window.innerWidth < 1024);
//     };
//     checkScreenSize();
//     window.addEventListener("resize", checkScreenSize);
//     return () => window.removeEventListener("resize", checkScreenSize);
//   }, []);

//   // Infinite auto scroll effect only on small/medium and when not hovered
//   useEffect(() => {
//     if (!isSmallOrMedium) return; // Don't auto scroll on large screens
//     const container = scrollContainerRef.current;
//     if (!container) return;

//     let animationFrame;
//     const scrollStep = 1; // pixels per frame
//     const maxScrollLeft = container.scrollWidth / 2;

//     const smoothScroll = () => {
//       if (isHovered) {
//         // Pause scrolling when hovered
//         animationFrame = requestAnimationFrame(smoothScroll);
//         return;
//       }
//       if (container.scrollLeft >= maxScrollLeft) {
//         container.scrollLeft -= maxScrollLeft;
//       } else {
//         container.scrollLeft += scrollStep;
//       }
//       animationFrame = requestAnimationFrame(smoothScroll);
//     };

//     animationFrame = requestAnimationFrame(smoothScroll);

//     return () => {
//       cancelAnimationFrame(animationFrame);
//     };
//   }, [isHovered, isSmallOrMedium]);

//   return (
//     <div className="w-full bg-white px-4 sm:px-6 lg:px-10">
//       <div className="mx-auto">
//         {/* Choose layout based on screen size */}
//         {isSmallOrMedium ? (
//           // Horizontal scrolling container for small and medium devices
//           <div
//             ref={scrollContainerRef}
//             className="flex gap-4 md:gap-6 overflow-x-auto whitespace-nowrap no-scrollbar"
//             style={{ scrollBehavior: "auto" }}
//             aria-label="Property categories horizontal scroll"
//           >
//             {doubledCategories.map((category, index) => (
//               <div
//                 key={index}
//                 className="relative overflow-hidden rounded-xl shadow-lg cursor-pointer h-48 sm:h-56 md:h-64 flex-shrink-0 w-[80%] md:w-[70%] lg:w-auto inline-block"
//                 onClick={() => handleCardClick(category.route)}
//                 role="button"
//                 tabIndex={0}
//                 onMouseEnter={() => setIsHovered(true)}
//                 onMouseLeave={() => setIsHovered(false)}
//                 onFocus={() => setIsHovered(true)}
//                 onBlur={() => setIsHovered(false)}

//                 aria-label={`View ${category.title}`}
//               >
//                 {/* Background Image */}
//                 <div className="absolute inset-0">
//                   <img
//                     src={category.image}
//                     alt={category.alt}
//                     className="w-full h-full object-cover"
//                   />
//                   {/* Overlay */}
//                   <div
//                     className="absolute inset-0"
//                     style={{
//                       background:
//                         "linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)",
//                       opacity: 0,
//                     }}
//                   ></div>
//                 </div>

//                 {/* Content */}
//                 <div className="relative h-full flex flex-col justify-between p-4 md:p-6">
//                   <div>
//                     <h3 className="font-[Poppins] font-semibold text-white tracking-[0.01em] leading-[159%] text-base sm:text-lg md:text-xl lg:text-2xl mb-2 w-1/2">
//                       {category.title}
//                     </h3>
//                     <p className="font-light text-[#C6C6C6] tracking-[0.01em] leading-[159%] text-xs sm:text-sm md:text-base lg:text-lg">
//                       {category.properties}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           // Grid layout for large and above screens (original UI unchanged)
//           <div className="grid grid-cols-3 gap-6">
//             {categories.map((category, index) => (
//               <div
//                 key={index}
//                 data-aos="fade-up"
//                 data-aos-delay={index * 200}
//                 className="relative overflow-hidden rounded-xl shadow-lg cursor-pointer h-48 sm:h-56 md:h-64 flex-shrink-0 w-auto"
//                 onClick={() => handleCardClick(category.route)}
//                 role="button"
//                 tabIndex={0}
//                 onKeyPress={(e) => {
//                   if (e.key === "Enter" || e.key === " ") {
//                     handleCardClick(category.route);
//                   }
//                 }}
//                 aria-label={`View ${category.title}`}
//               >
//                 {/* Background Image */}
//                 <div className="absolute inset-0">
//                   <img
//                     src={category.image}
//                     alt={category.alt}
//                     className="w-full h-full object-cover"
//                   />
//                   {/* Overlay */}
//                   <div
//                     className="absolute inset-0"
//                     style={{
//                       background:
//                         "linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%)",
//                       opacity: 0,
//                     }}
//                   ></div>
//                 </div>

//                 {/* Content */}
//                 <div className="relative h-full flex flex-col justify-between p-4 md:p-6">
//                   <div>
//                     <h3 className="font-[Poppins] font-semibold text-white tracking-[0.01em] leading-[159%] text-base sm:text-lg md:text-xl lg:text-2xl mb-2 w-1/2">
//                       {category.title}
//                     </h3>
//                     <p className="font-light text-[#C6C6C6] tracking-[0.01em] leading-[159%] text-xs sm:text-sm md:text-base lg:text-lg">
//                       {category.properties}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default PropertyCategories;
